var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMotos = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    d: "M31.376 29.9997C31.376 30.7192 31.5177 31.4315 31.793 32.0962C32.0683 32.7608 32.4718 33.3648 32.9805 33.8735C33.4892 34.3822 34.0931 34.7857 34.7578 35.061C35.4224 35.3363 36.1348 35.478 36.8542 35.478C37.5736 35.478 38.286 35.3363 38.9507 35.061C39.6153 34.7857 40.2192 34.3822 40.7279 33.8735C41.2366 33.3648 41.6402 32.7608 41.9155 32.0962C42.1908 31.4315 42.3325 30.7192 42.3325 29.9997C42.3325 29.2803 42.1908 28.568 41.9155 27.9033C41.6402 27.2387 41.2366 26.6347 40.7279 26.126C40.2192 25.6173 39.6153 25.2138 38.9507 24.9385C38.286 24.6632 37.5736 24.5215 36.8542 24.5215C36.1348 24.5215 35.4224 24.6632 34.7578 24.9385C34.0931 25.2138 33.4892 25.6173 32.9805 26.126C32.4718 26.6347 32.0683 27.2387 31.793 27.9033C31.5177 28.568 31.376 29.2803 31.376 29.9997V29.9997Z",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M6.33301 30.7835C6.33301 31.4002 6.45446 32.0108 6.69044 32.5805C6.92642 33.1502 7.2723 33.6678 7.70833 34.1039C8.14436 34.5399 8.66201 34.8858 9.23171 35.1218C9.80141 35.3577 10.412 35.4792 11.0287 35.4792C11.6453 35.4792 12.2559 35.3577 12.8256 35.1218C13.3953 34.8858 13.913 34.5399 14.349 34.1039C14.785 33.6678 15.1309 33.1502 15.3669 32.5805C15.6029 32.0108 15.7243 31.4002 15.7243 30.7835C15.7243 30.1669 15.6029 29.5563 15.3669 28.9866C15.1309 28.4169 14.785 27.8992 14.349 27.4632C13.913 27.0272 13.3953 26.6813 12.8256 26.4453C12.2559 26.2093 11.6453 26.0879 11.0287 26.0879C10.412 26.0879 9.80141 26.2093 9.23171 26.4453C8.66201 26.6813 8.14436 27.0272 7.70833 27.4632C7.2723 27.8992 6.92642 28.4169 6.69044 28.9866C6.45446 29.5563 6.33301 30.1669 6.33301 30.7835V30.7835Z",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11.0283 30.7833L20.825 26.7012",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M42.3307 21.3593C42.3307 21.3593 40.0158 17.4791 33.7549 19.8269",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M32.553 15.9139C29.5947 16.5422 26.5705 16.8051 23.5483 16.6965C18.1717 16.6965 12.6982 15.0483 8.20914 14.4895C7.78988 14.437 7.3663 14.5454 7.02389 14.793C6.68148 15.0406 6.44576 15.4088 6.36431 15.8234C6.28286 16.2381 6.36174 16.6681 6.58504 17.0269C6.80834 17.3856 7.15941 17.6462 7.5674 17.7561C10.465 18.5176 13.2192 19.7456 15.7222 21.3921C20.4178 24.5226 20.4178 28.4356 24.3309 28.4356H25.8961C28.3425 28.4356 29.3208 21.7584 33.7551 19.8269",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M29.1526 16.4476L27.4637 19.8253H22.7681L18.3213 16.2676",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M36.8546 30L31.6048 12.7482C31.5385 12.5317 31.4045 12.3422 31.2225 12.2075C31.0405 12.0729 30.8201 12.0001 30.5937 12H26.6807",
    stroke: props.color || 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgMotos;